<template>
  <validation-observer
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="type-of-driving"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <!-- TYPE OF DRIVING GENERIC -->
      <form-row
        :label="!isAdditional ? 'What kind of driving licence do you have?' : 'What kind of driving licence do they have?'"
        :error="formObserver.validated && observer.invalid"
      >
        <template slot="helpText">
          <p>
            <strong>Why do we ask?</strong>
            <br>
            The type of licence {{ isAdditional ? 'they' : 'you' }} have shows the insurance providers how experienced {{ isAdditional ? 'they' : 'you' }} are behind the wheel.
          </p>
        </template>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_type-of-driving`"
          name="Driving License"
          :rules="{ is_not: { other: null } }"
        >
          <radio
            v-model="typeOfDrivingGenericModel"
            :name="`${stepId}.type-of-driving`"
            :data-test="fieldTrackerId.main"
            :items="driverTypeOfDrivingGeneric"
            :error="failed"
            :error-messages="failed
              ?
                [`Please select ${isAdditional ? 'their' : 'your'} licence type.`]
              : []"
            column
            return-object
          />
        </validation-provider>
      </form-row>
      <!-- TYPE OF DRIVING OTHER -->
      <form-row
        v-if="typeOfDrivingGenericModel !== null && !constants.DRIVER_TYPE_OF_DRIVING_FAVORITES.includes(typeOfDrivingGenericModel)"
        gap="16"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_type-of-driving`"
          name="Driving License (Other)"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.typeOfDriving"
            :data-test="fieldTrackerId.other"
            :items="driverTypeOfDrivingOther"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select type of licence', isMobile)"
            :error-messages="errors"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import {
  omit,
  pick,
  snakeCase,
} from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-type-of-driving',
  extends: QuestionBase,
  data () {
    return {
      fields: ['typeOfDriving'],
    };
  },
  computed: {
    driverTypeOfDrivingGeneric () {
      return [
        ...this.helpers.createOptions({ source: pick(this.constants.DRIVER_TYPE_OF_DRIVING, this.constants.DRIVER_TYPE_OF_DRIVING_FAVORITES) }),
        this.constants.OTHER_OPTIONS,
      ];
    },
    driverTypeOfDrivingOther () {
      return this.helpers.createOptions({ source: omit(this.constants.DRIVER_TYPE_OF_DRIVING, this.constants.DRIVER_TYPE_OF_DRIVING_FAVORITES) });
    },
    typeOfDrivingGenericModel: {
      get () {
        if (this.questionData.typeOfDriving === null) return null;
        return this.constants.DRIVER_TYPE_OF_DRIVING_FAVORITES.includes(this.questionData.typeOfDriving) ? this.questionData.typeOfDriving : true;
      },
      set (val) {
        this.questionData.typeOfDriving = val.logical ? val.logicalValue : val.value;
      },
    },
    fieldTrackerId () {
      return {
        main: snakeCase(this.questionFields.typeOfDriving),
        other: `${snakeCase(this.questionFields.typeOfDriving)}_other`,
      };
    },
  },
};
</script>
